import {api} from 'boot/axios';

export default {
  getExtrasList: function () {
    return api.get('vehicles/extras/')
  },
}
